export default "__VITE_ASSET__DKJoCnSy__"